import { FC } from "react";
import { Box, Button, Typography, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ReplayIcon from "@mui/icons-material/Replay";

import { Colors } from "../../../configs";

// import CheckInLayout from "../../../components/layouts/pos-layout/CheckInLayout";
import CustomerDetailSection from "../../../components/common/pos/customer-detail-section/customer-detail-section";
import OrderDetailSection from "../../../components/common/pos/order-detail-section/order-detail-section";
import CartSection from "../../../components/common/pos/cart-section/cart-section";
import CartQtyHandlerSection from "../../../components/common/pos/cart-qty-handler-section/cart-qty-handler-section";
import ServiceTabMenu from "../../../components/common/pos/service-tab-menu/service-tab-menu";
import GarmentTypeSection from "../../../components/common/pos/garment-type-section/garment-type-section";
import GarmentModificationSection from "../../../components/common/pos/garment-modification-section/garment-modification-section";
import MoreIcon from "../../../assets/images/more";
import GarmentDesignVariationSection from "../../../components/common/pos/garment-design-variation-section/garment-design-variation-section";
import { CustomButton, PosLayout } from "../../../components";

export interface IAlterationProps {}

const Alteration: FC<IAlterationProps> = () => {
  return (
    <PosLayout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          padding: "2.28571429rem",
          height: "100%",
          gap: "0.928571429rem",
        }}
      >
        <Box
          sx={{
            flex: 4,
            display: "flex",
            flexDirection: "column",
            gap: "1.07142857rem",
            height: "100%",
            maxHeight: "100% !important",
          }}
        >
          <CustomerDetailSection
            showAnalysisButton={true}
            showEditButton={true}
            showHistoryButton={true}
          />
          <CartSection onSelect={() => {}} />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "1.07142857rem",
              flexShrink: 0,
            }}
          >
            <OrderDetailSection />
            <Box
              sx={{ display: "flex", flexDirection: "column", gap: "0.71rem" }}
            >
              <CartQtyHandlerSection />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  gap: "0.71rem",
                }}
              >
                <CustomButton
                  sx={{
                    background: Colors.MAIN_GRAY,
                    padding: "1.17857143rem",
                    aspectRatio: "1/1",
                    borderRadius: "0.71rem",
                  }}
                >
                  <DeleteIcon
                    sx={{ color: Colors.WHITE, fontSize: "1.78571429rem" }}
                  />
                </CustomButton>
                <CustomButton
                  sx={{
                    background: Colors.MAIN_GRAY,
                    color: Colors.WHITE,
                    fontSize: "1.42857143rem",
                    padding: "1.17857143rem",
                    flexGrow: 1,
                    borderRadius: "0.71rem",
                    textTransform: "capitalize",
                  }}
                >
                  Notes
                </CustomButton>
                <CustomButton
                  sx={{
                    background: Colors.MAIN_GRAY,
                    color: Colors.WHITE,
                    fontSize: "1.42857143rem",
                    padding: "1.17857143rem",
                    flexGrow: 1,
                    borderRadius: "0.71rem",
                    textTransform: "capitalize",
                  }}
                >
                  Customization
                </CustomButton>
              </Box>
              <CustomButton
                sx={{
                  width: "100%",
                  fontSize: "2.28571429rem",
                  borderRadius: "0.71rem",
                  background: Colors.PRIMARY,
                  color: Colors.WHITE,
                  textTransform: "capitalize",
                  flexGrow: 1,
                }}
              >
                Check In
              </CustomButton>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{ width: "0.142857143rem", background: Colors.ACCENT_GRAY }}
        ></Box>
        <Box
          sx={{
            flex: 5,
            display: "flex",
            flexDirection: "column",
            gap: "1.42857143rem",
          }}
        >
          <Typography sx={{ fontSize: "2.57rem", color: "#4D4D4D" }}>
            Alteration
          </Typography>
          <ServiceTabMenu currentTab="Alteration" />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "0.71rem",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ flex: 8 }}>
              <GarmentTypeSection />
            </Box>
            <Box sx={{ flex: 4 }}>
              <GarmentModificationSection />
            </Box>
          </Box>
          <GarmentDesignVariationSection />
          <Box
            sx={{
              flexShrink: 1,
              background: Colors.BACKGROUND_GRAY,
              borderRadius: "0.71rem",
              padding: "0.928571429rem",
            }}
          >
            <Typography sx={{ height: "3.42857143rem" }}>
              Shorten - Plain Bottom, Taper - Knees Down, Sew - Seat Seam
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: "auto",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0rem 0.928571429rem",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "2.5rem",
              }}
            >
              <IconButton style={{ width: "4.59rem", borderRadius: "50%" }}>
                <MoreIcon color={Colors.ACCENT_GRAY_DISABLED} size={45} />
              </IconButton>
              <CustomButton
                sx={{
                  background: "none",
                  border: `0.214285714rem solid ${Colors.TEXT_GRAY_DARK}`,
                  color: Colors.TEXT_GRAY_DARK,
                  fontSize: "2.57142857rem",
                  lineHeight: "3rem",
                  padding: "1.15142857rem 3rem",
                  borderRadius: "0.71rem",
                  textTransform: "capitalize",
                  fontWeight: 400,
                }}
              >
                Pickups
              </CustomButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "1.21428571rem",
                height: "100%",
              }}
            >
              <IconButton
                sx={{
                  height: "100%",
                  aspectRatio: "1/1",
                  background: Colors.SECONDARY,
                  borderRadius: "0.71rem",
                }}
              >
                <ReplayIcon style={{ fontSize: "3rem", color: Colors.WHITE }} />
              </IconButton>
              <CustomButton
                sx={{
                  background: Colors.PRIMARY,
                  color: Colors.WHITE,
                  fontSize: "2.57142857rem",
                  lineHeight: "3rem",
                  padding: "1.15142857rem 3rem",
                  borderRadius: "0.71rem",
                  textTransform: "capitalize",
                  fontWeight: 400,
                  height: "100%",
                  whiteSpace: "nowrap",
                  "&:hover": { background: `${Colors.PRIMARY} !important` },
                }}
              >
                Add Item
              </CustomButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </PosLayout>
  );
};

export default Alteration;
